import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/globals.css';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY — add to .env');
}

// The Clerk app is shared with the Reporting Hub, so its application name isn't ours.
// Override the sign-in copy and hide the sign-up link (access is admin-only).
const clerkLocalization = {
  signIn: { start: { title: 'Sign in to Allstar Lender Reporting', subtitle: 'Authorized users only' } },
};
const clerkAppearance = { elements: { footerAction: { display: 'none' } } };

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      localization={clerkLocalization}
      appearance={clerkAppearance}
      signInForceRedirectUrl="/"
      signUpForceRedirectUrl="/"
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ClerkProvider>
  </React.StrictMode>
);
